import type { Component } from 'solid-js'
import { useTransContext } from '@mbarzda/solid-i18next'
import type { SectionPeriod } from '../../../features/engagement/domain/models/sections'
import { ChartContainerWithHeader, useChart } from '../../shared/charts'
import { getSectionsTotalsChartOptions } from './SectionsTotalsChart.vm'

interface SectionsTotalsChartProps {
  periods: SectionPeriod[]
}

const SectionsTotalsChart: Component<SectionsTotalsChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const [t] = useTransContext()

  useChart({
    data: () => props.periods,
    chartRef: () => chartRef,
    buildOptions: (periods) => getSectionsTotalsChartOptions(periods, t)
  })

  return (
    <ChartContainerWithHeader hasData={props.periods.length > 0} title={t('ls_sections_totals_title')}>
      <div ref={chartRef} />
    </ChartContainerWithHeader>
  )
}

export default SectionsTotalsChart
